export interface ChartWeeksSalesInvoices {
  invoiceDate: Date;
  numberOfInvoices: number;
  quantity: number;
  value: number;
}
